import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Bootstrap components
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// Custom Styles
import "../scss/pages/postGraduates.styles.scss";

// Axios
import axios from "axios";

// Assets
import CourseMedia from "../assets/img/course-media.jpg";
import PostGraduatesAboutMedia from "../assets/img/educational-offer-about.jpg";
import { resolveStrapiMediaUrl } from "../utils/strapiMedia";

function getPosgradoImageUrl(course) {
  const raw = course?.attributes?.imagen?.data?.attributes?.url;
  return resolveStrapiMediaUrl(raw) ?? CourseMedia;
}

function PostGraduates() {
  const [postgraduateData, setPostgraduateData] = useState([]);
  const [postgraduateCoursesData, setPostgraduateCoursesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingPostGraduateCourses, setLoadingPostGraduateCourses] =
    useState(true);
  const [error, setError] = useState({ error: false, message: "" });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/graphql`,
          {
            query: `
            {
              cursoPosgrado{
                data{
                  attributes{
                    Titulo
                    Parrafo
                    AcercaDePosgrados{
                      Titulo
                      Informacion
                      imagen{
                        data{
                          attributes{
                            url
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
          }
        );
        setPostgraduateData(response.data.data.cursoPosgrado.data.attributes);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError({ error: true, message: error.message || error.toString() });
      } finally {
        setLoading(false);
      }
      // console.log(response.data.data);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/graphql`,
          {
            query: `
            {
              posgrados{
                data{
                  id
                  attributes{
                    Nombre
                    Descripcion
                    imagen{
                      data{
                        attributes{
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
          }
        );
        setPostgraduateCoursesData(response.data.data.posgrados.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError({ error: true, message: error.message || error.toString() });
      } finally {
        setLoadingPostGraduateCourses(false);
      }
      // console.log(response.data.data);
    };

    fetchData();
  }, []);

  if (loading || loadingPostGraduateCourses) {
    return (
      <section className="loading">
        <Container>
          <h6>Cargando información...</h6>
        </Container>
      </section>
    );
  }
  if (error.error) {
    return (
      <section className="loading">
        <Container>
          <h6>No se pudo cargar la información en este momento ⌛️</h6>
        </Container>
      </section>
    );
  }
  return (
    <>
      <section className="postGraduates__jumbotron jumbotron--informative">
        <h2>Posgrados</h2>
      </section>
      <section className="postGraduates">
        <Container fluid>
          <div className="postGraduates__heading">
            <div className="spacer--red"></div>
            <h5>{postgraduateData.Titulo}</h5>
            <p>{postgraduateData.Parrafo}</p>
          </div>
          <div className="postGraduates__list">
            {postgraduateCoursesData.map((course) => (
              <div className="postGraduates__list__item" key={course.id}>
                <div className="postGraduates__list__item__media">
                  <img src={getPosgradoImageUrl(course)} alt="" />
                </div>
                <div className="postGraduates__list__item__body">
                  <h6>{course.attributes.Nombre}</h6>
                  <p>{course.attributes.Descripcion}</p>
                  <Link to={`/maestrias/${course.id}`}>Más información</Link>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
      {/* <section className="postGraduates__about">
        <Container fluid>
          <Row>
            <Col
              xs="12"
              lg="6"
              className="d-flex flex-column justify-content-center"
            >
              {postgraduateData.AcercaDePosgrados !== null && (
                <h3>{postgraduateData.AcercaDePosgrados.Titulo}</h3>
              )}

              {postgraduateData.AcercaDePosgrados !== null &&
                renderInformacionContent(
                  postgraduateData.AcercaDePosgrados.Informacion
                )}
            </Col>
            <Col xs="12" lg="6">
              {postgraduateData.AcercaDePosgrados !== null &&
                postgraduateData.AcercaDePosgrados.imagen.data !== null && (
                  <div className="postGraduates__about__media">
                    <img
                      src={
                        resolveStrapiMediaUrl(
                          postgraduateData.AcercaDePosgrados.imagen.data
                            .attributes.url
                        ) ?? PostGraduatesAboutMedia
                      }
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                )}
            </Col>
          </Row>
        </Container>
      </section> */}
    </>
  );
}

export default PostGraduates;
